<template>
</template>

<script>
import { mapState } from 'vuex';
import { ensureGtmLoaded, pushEcommerceEvent, buildPurchaseItem, readMap, writeMap } from 'assets/js/gtm';

const BEGIN_CHECKOUT_FINGERPRINT_KEY = 'gtm_begin_checkout_fingerprint';

export default {
    name: "PT504GTMPurchase",
    data() {
        return {
            eventSent: false,
        };
    },
    computed: {
        ...mapState('sh070', ['sh070Init', 'sh070Request']),
        orderInfo() {
            return this.sh070Init && Array.isArray(this.sh070Init.orderInfo) ? this.sh070Init.orderInfo : [];
        },
        orderDtlInfo() {
            return this.sh070Init && Array.isArray(this.sh070Init.orderDtlInfo) ? this.sh070Init.orderDtlInfo : [];
        },
        primaryOrder() {
            return this.orderInfo.length > 0 ? this.orderInfo[0] : {};
        },
        gtmContainerId() {
            return this.sh070Init && this.sh070Init.gtmcontainerId ? this.sh070Init.gtmcontainerId : '';
        },
        eventPayloadReady() {
            return !!this.gtmContainerId && this.orderInfo.length > 0 && this.orderDtlInfo.length > 0;
        }
    },
    watch: {
        eventPayloadReady: {
            handler(ready) {
                if (ready) {
                    this.$nextTick(() => {
                        this.initAndPushPurchase();
                    })
                }
            },
            immediate: true,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initAndPushPurchase();
        });
    },
    methods: {
        hasOrderCompleteRoot() {
            return !!document.querySelector('#sh070');
        },
        canRunInContext() {
            return this.hasOrderCompleteRoot();
        },
        initAndPushPurchase() {
            if (!this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            this.$store.commit('setGtmId', this.gtmContainerId);
            // GTM コンテナが初期化されていることを保証します。
            ensureGtmLoaded();
            setTimeout(() => {
                this.pushPurchase();
            }, 200);
        },
        clearBeginCheckoutFingerprint() {
            try {
                sessionStorage.removeItem(BEGIN_CHECKOUT_FINGERPRINT_KEY);
            } catch (e) {
                // ignore sessionStorage errors
            }
        },
        pushPurchase() {
            if (this.eventSent || !this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            const items = this.orderDtlInfo.map(item => buildPurchaseItem(item));
            const value = this.orderInfo.reduce((total, item) => {
                const subtotal = Number(item.ITEMSUM_TAX_EX);
                return total + (Number.isNaN(subtotal) ? 0 : subtotal);
            }, 0);
            const tax = Number(this.primaryOrder.SORYO_TAX_IN) + Number(this.primaryOrder.ITEMSUM_TAX);

            pushEcommerceEvent('purchase', {
                transaction_id: this.primaryOrder.ORDER_CD,
                currency: 'JPY',
                value,
                tax,
                items,
            });
            //注文が成功した後、begin_checkoutの指紋をクリアし、次回の決済プロセスに影響が出ないようにしてください。
            this.clearBeginCheckoutFingerprint();

            // 注文が成功した後、ソースをクリアする
            const map = readMap()
            items.forEach(item => {
                delete map[item.item_id]
            })
            writeMap(map)
            this.eventSent = true;
        }
    }
}
</script>
